import React from "react";

interface BoxProps {
  color: string;
  text: string;
}

const Box: React.FC<BoxProps> = ({ color, text }) => {
  return (
    <div
      className={`w-20 h-20 flex justify-center items-center text-5xl text-slate-800 font-bold rounded-lg border-maroon-500 ${color} relative shadow-lg transform transition-transform duration-300 hover:translate-y-[-5px]`}
    >
      {text}
    </div>
  );
};

interface LogoProps {
  textArray: string[];
}

const Logo: React.FC<LogoProps> = ({ textArray }) => {
  const colors = [
    "bg-gradient-to-tr from-pink-200 to-pink-300",
    "bg-gradient-to-tr from-blue-200 to-blue-300",
  ];

  return (
    <div className="flex flex-col gap-2 p-4">
      <div className="flex justify-center items-center gap-2">
        {textArray.slice(0, 2).map((text, index) => (
          <Box key={index} color={colors[index % colors.length]} text={text} />
        ))}
      </div>
      <div className="flex justify-center items-center gap-2">
        {textArray.slice(2, 4).map((text, index) => (
          <Box
            key={index + 2}
            color={colors[1 - (index % colors.length)]}
            text={text}
          />
        ))}
      </div>
    </div>
  );
};

export default Logo;
